import { createElement } from 'react';
import Marquee from 'react-fast-marquee';
const DataVMarquee = (props) => {
    return createElement(Marquee, { ...props });
};
export default DataVMarquee;
